/* tslint:disable */
/* eslint-disable */
/**
 * home-health-api
 * home-health-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { HchbFacilitySummary } from './HchbFacilitySummary';
import {
    HchbFacilitySummaryFromJSON,
    HchbFacilitySummaryFromJSONTyped,
    HchbFacilitySummaryToJSON,
} from './HchbFacilitySummary';

/**
 * 
 * @export
 * @interface HchbFacilityPage
 */
export interface HchbFacilityPage {
    /**
     * 
     * @type {Array<HchbFacilitySummary>}
     * @memberof HchbFacilityPage
     */
    data: Array<HchbFacilitySummary>;
    /**
     * 
     * @type {number}
     * @memberof HchbFacilityPage
     */
    page: number;
    /**
     * 
     * @type {number}
     * @memberof HchbFacilityPage
     */
    limit: number;
    /**
     * 
     * @type {number}
     * @memberof HchbFacilityPage
     */
    total: number;
    /**
     * 
     * @type {boolean}
     * @memberof HchbFacilityPage
     */
    has_next: boolean;
}

/**
 * Check if a given object implements the HchbFacilityPage interface.
 */
export function instanceOfHchbFacilityPage(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "data" in value;
    isInstance = isInstance && "page" in value;
    isInstance = isInstance && "limit" in value;
    isInstance = isInstance && "total" in value;
    isInstance = isInstance && "has_next" in value;

    return isInstance;
}

export function HchbFacilityPageFromJSON(json: any): HchbFacilityPage {
    return HchbFacilityPageFromJSONTyped(json, false);
}

export function HchbFacilityPageFromJSONTyped(json: any, ignoreDiscriminator: boolean): HchbFacilityPage {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': ((json['data'] as Array<any>).map(HchbFacilitySummaryFromJSON)),
        'page': json['page'],
        'limit': json['limit'],
        'total': json['total'],
        'has_next': json['has_next'],
    };
}

export function HchbFacilityPageToJSON(value?: HchbFacilityPage | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': ((value.data as Array<any>).map(HchbFacilitySummaryToJSON)),
        'page': value.page,
        'limit': value.limit,
        'total': value.total,
        'has_next': value.has_next,
    };
}

